import api, { apiSetup } from '../api';

apiSetup(undefined);

/** A link under "Estudios" in the menu (usually a study's PDF), its title in the current language. */
export interface Study {
  id: number;
  title: string;
  url: string;
  order: number;
}

/** The studies in the order set in the backoffice. */
export const getStudies = () => api.get<Study[]>('/studies/');
